import Checkbox from 'components/ui/base/checkbox/Checkbox';
import styled from 'styled-components';
import { InputDiv } from '../formInput/DeclarationInput.styles';

export const StyledCheckbox = styled(Checkbox)`
    align-self: flex-start;
`;

export const CheckboxInputDiv = styled(InputDiv)`
    align-items: center;
    gap: 0.8rem;
`;

export const SourceIconWrapper = styled.span`
    margin-left: 0.6rem;
`;
